/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsAdvertisementYandexRewardedOptions, FxIdDomainSettingsAdvertisementYandexRewardedOptionsFromJSONTyped, FxIdDomainSettingsAdvertisementYandexRewardedOptionsToJSON, } from './FxIdDomainSettingsAdvertisementYandexRewardedOptions';
export function FxIdDomainSettingsAdvertisementYandexOptionsRewardedFromJSON(json) {
    return FxIdDomainSettingsAdvertisementYandexOptionsRewardedFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementYandexOptionsRewardedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementYandexRewardedOptions(json)) {
        return FxIdDomainSettingsAdvertisementYandexRewardedOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsAdvertisementYandexOptionsRewardedToJSON(json) {
    return FxIdDomainSettingsAdvertisementYandexOptionsRewardedToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementYandexOptionsRewardedToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementYandexRewardedOptions(value)) {
        return FxIdDomainSettingsAdvertisementYandexRewardedOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementYandexOptionsRewarded.js.map